<template>
    <div>
        <div class="offer-header">
            <div class="page-title">
                <h4> {{$t('txt.editeazaComanda')}} </h4>
            </div>
            <div class="action-button-group">
                <div class="preview-template-button action-button" :class="{'action-button-active': action_button_state === 1}">
                    <button type="button" @click="showModal()">
                        <i class="far fa-eye"></i>
                    </button>
                    <div class="teardrop-text">
                      <span> Previzualizeaza </span>
                    </div>
                </div>
                <div class="preview-products-list action-button" :class="{'action-button-active': action_button_state === 2}">
                    <button type="button" @click="toggleSlideOut('products')" v-shortkey="['alt', '2']" @shortkey="toggleSlideOut('products')">
                        <i class="fas fa-th"></i>
                    </button>
                    <div class="teardrop-text">
                      <span> Adauga produse </span>
                    </div>
                </div>
                <div class="preview-offers-list action-button" :class="{'action-button-active': action_button_state == 3}">
                   <button type="button" @click="toggleSlideOut('offers')" v-shortkey="['alt', '3']" @shortkey="toggleSlideOut('offers')">
                        <i class="far fa-list-alt"></i>
                    </button>
                    <div class="teardrop-text">
                      <span> Adauga oferte </span>
                    </div>
                </div>
                <div class="preview-template-button action-button" :class="{'action-button-active': action_button_state === 4}">
                    <button type="button" @click="toggleSlideOut('table-config')" v-shortkey="['alt', '4']" @shortkey="toggleSlideOut('table-config')">
                        <i class="fas fa-network-wired"></i>
                    </button>
                    <div class="teardrop-text">
                      <span> Configurare Tabel </span>
                    </div>
                </div>
                <!--<div class="preview-orders-list action-button" @click="action_button_state = 3" :class="{'action-button-active': action_button_state == 3}">
                    <button type="button" @click="toggleSlideOut('orders')" v-shortkey="['alt', '3']" @shortkey="toggleSlideOut('orders')">
                        <i class="far fa-list-alt"></i>
                    </button>
                    <span> Adauga comenzi </span>
                </div>-->
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
                <clients ref="clientCompRef" :select_client_clone='select_client_clone'/>
            </div>
        </div>
        <div class="composition-template" id='composition-template-event'>
            <div class="general-template-info">
                <ul id="template-info-list">
                    <li class="template-list-item">
                        <p class="main-heading"> {{$t('txt.numarComanda')}} </p>
                        <p> AUTO  </p>
                    </li>
                    <li class="template-list-item">
                        <p class="main-heading"> {{$t('txt.data')}}:  </p>
                        <p> {{new Date() | moment("DD.MM.YYYY")}} </p>
                    </li>
                    <li class="template-list-item">
                        <p class="main-heading"> {{$t('txt.statusComanda')}} </p>
                        <div class="template-select-status">
                            <v-select v-model="selected_status" label="label" :options="status"></v-select>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="offer-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        <th>
                            <p>
                                {{$t('tableHeader.nrCrt')}}
                            </p>
                        </th>
                        <th v-if="!checkboxes['name_check'].value">
                            <p class="final-table-header">
                                {{$t('placeholder.denumire')}}
                            </p>
                        </th>
                        <th v-if="!checkboxes['price_check'].value" class="tablehead-price">
                            <div class="type-price-header">
                                <p> {{$t('placeholder.tipPret')}} </p>
                                <b-form-select v-model="globalPriceRange.key" @input="changePriceProducts()">
                                    <option v-for="(ppCateg, index) in priceCategoryes" :key="index" :value="ppCateg.value">{{ ppCateg.display }}</option>
                                </b-form-select>
                            </div>
                        </th>
                        <th v-if="!checkboxes['addition_check'].value">
                            <p class="final-table-header">
                                {{$t('tableHeader.adaos')}}
                            </p>
                        </th>
                        <th v-if="!checkboxes['discount_check'].value">
                            <p class="final-table-header">
                                {{$t('tableHeader.discount')}}
                            </p>
                        </th>
                        <th v-if="!checkboxes['quantity_check'].value">
                            <p class="final-table-header">
                                {{$t('placeholder.cantitate')}}
                            </p>
                        </th>
                        <th v-if="!checkboxes['subtotal_check'].value">
                            <p class="final-table-header">
                                {{$t('txt.subtotal')}}
                            </p>
                        </th>
                        <th>
                            <p class="final-table-header">
                                <!-- {{$t('placeholder.sterge')}} -->
                            </p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order_row, index) in order_rows.products" :data-order-row-id="order_row.id" :key="order_row.id">
                        <td>
                            <p> {{index + 1}} </p>
                        </td>
                        <td  v-if="!checkboxes['name_check'].value" :tableheadData="$t('placeholder.denumire')" class="order-prdname-wrapper" :class="(parseFloat(order_row.prices['pp_minim']) > parseFloat(order_row.price)) ? 'price-under-min' : ''">
                            <div class="final-offer-name final-order-name">
                                <p> {{order_row.name}} </p>
                            </div>
                        </td>
                        <td v-if="!checkboxes['price_check'].value" :tableheadData="$t('placeholder.pret')">
                            <div class="type-price">
                                <b-form-select v-model="order_row.price_category" @change="changePriceProduct(index)">
                                    <option v-for="(ppCateg, index) in priceCategoryes" :key="index" :value="ppCateg.value"> {{ ppCateg.display }} &nbsp; | &nbsp; {{ order_row.prices[ppCateg.name] }}</option>
                                </b-form-select>
                                <i v-if="order_row.price_category_indicator === 'up' " class="fas fa-plus"></i>
                                <i v-if="order_row.price_category_indicator === 'down' " class="fas fa-minus"></i>
                                <i v-if="order_row.price_category_indicator !== 'down' && order_row.price_category_indicator !== 'up'" class="far fa-circle"></i>
                                <input type="number" v-model="order_row.price" :data-price-active="index"  @input="changePriceProductInput(index)" @click="activatePriceInput(index)" @keypress.enter="increaseDataPrice()"/>
                            </div>
                        </td>
                        <td  v-if="!checkboxes['addition_check'].value" :tableheadData="$t('tableHeader.adaos')" class="price-modifier-wrapper">
                            <div class="modifier-wrapper">
                                <div class="item-price-modifier addition-modifier" v-bind:class="{'addition-modifier-inactive': check_addition}">
                                    <input type="number" v-model="order_row.addition" :data-addition-active="index" min="1" max="100"
                                                        @input="inputAdditionProduct(index)"
                                                        @change="changeAdditionDiscountProduct(index)"
                                                        @keypress.enter="increaseDataAddition()"
                                                        @click="activateAdditionInput(index)">
                                    <i class="fas fa-percentage"></i>
                                </div>
                                <i class="fas fa-arrow-down arrow-cursor" @dblclick="changeAdditionUnder(index)"></i>
                            </div>
                        </td>
                        <td v-if="!checkboxes['discount_check'].value"  :tableheadData="$t('tableHeader.discount')" class="price-modifier-wrapper">
                            <div class="modifier-wrapper">
                                <div class="item-price-modifier">
                                    <input type="number" v-model="order_row.discount" :data-discount-active="index" min="1" max="100"
                                                        @input="inputDiscountProduct(index)"
                                                        @change="changeAdditionDiscountProduct(index)"
                                                        @keypress.enter="increaseDataDiscount()"
                                                        @click="activateDiscountInput(index)">
                                    <i class="fas fa-percentage"></i>
                                </div>
                                <i class="fas fa-arrow-down arrow-cursor" @dblclick="changeDiscountUnder(index)"></i>
                            </div>
                        </td>
                        <td width="10%" v-if="!checkboxes['quantity_check'].value" :tableheadData="$t('placeholder.cantitate')">
                          <div class="item-qty-modifier">
                            <input type="number" v-model="order_row.qty" :data-qty-active="index" min="1" @keypress.enter="increaseDataQty()" @click="activateQtyInput(index)" @input="changeQty(index)">
                            <span>{{order_row.um}}</span>
                          </div>
                        </td>
                        <td v-if="!checkboxes['subtotal_check'].value"  :tableheadData="$t('txt.subtotal')">
                            <div class="final-offer-price">
                                <!-- <p> {{(order_row.price * order_row.qty) + (order_row.addition || 0)/100*(order_row.price * order_row.qty) - (order_row.discount || 0)/100*(order_row.price * order_row.qty)  | formatPrice}} </p> -->
                                <p> {{(order_row.price * order_row.qty) | formatPrice}} </p>
                                <!--<p> RON </p>-->
                            </div>
                        </td>
                        <td :tableheadData="$t('placeholder.sterge')">
                            <div class="final-offer-remove" @click="removeItem(index, 'products')">
                                <i class="fas fa-times"></i>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="composition-info">
            <ul>
                <li>
                    <h5> {{$t('txt.subtotal')}}  </h5>
                    <p> {{subtotal() | formatPrice}} </p>
                </li>
                  <li>
                       <h5> {{$t('tableHeader.discount')}}  </h5>
                       <span class="discount-label"> <i class="fas fa-percentage"></i> </span>
                       <input type="number" v-model="discount" min="1" max="100">
                   </li>
                <li>
                    <h5> {{$t('txt.total')}}  </h5>
                    <p> {{total() | formatPrice}}</p>
                </li>
                <li>
                    <div class="discount-check-line">
                        <b-form-checkbox
                                v-b-tooltip.hover :title="totalDiscountCheckbox ?  'Nu afisa in comanda' : 'Afiseaza in comanda'"
                                name="discount-check"
                                v-model="totalDiscountCheckbox"
                        >
                        </b-form-checkbox>
                        <h5> Discount total </h5>
                    </div>
                    <p> {{this.discountTotal().value | formatPrice}} ({{this.discountTotal().percentage | formatPrice}} %) </p>
                </li>
                <li class="addition-info-line" v-if="!check_addition" v-bind:class="{'addition-modifier-inactive': check_addition}">
                    <h5> Adaos total </h5>
                    <p> {{this.addition().value | formatPrice}} ({{this.addition().percentage | formatPrice}} %) </p>
                </li>
                <li class="final-info-save">
                  <button class="template-button" type="button" @click="saveOrder()">
                      <i class="far fa-save"></i>
                      {{$t('placeholder.salveazaComanda')}}
                  </button>
                </li>
            </ul>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="template-additional-info">
                    <div class="additional-info-input">
                        <div class="additional-info additional-first">
                            <label for="objectiv">
                                <i v-if="search_results_orders.length || search_results_offers.length" class="fas fa-exclamation-triangle"></i>
                                Obiectivul:
                            </label>
                            <input
                                    v-model="objective"
                            />
                            <ul class="search-similar-results">
                                <li v-for="order in search_results_orders" :key="order.id"> Comanda {{order.id}} -  {{order.objective}}</li>
                                <li v-for="offer in search_results_offers" :key="offer.id"> Oferta {{offer.id}} -  {{offer.objective}}</li>
                            </ul>
                        </div>
                        <div class="additional-info additional-second">
                            <label for="representative_prod">
                                Produse Reprezentative:
                            </label>
                            <input
                                    v-model="representative_products"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-config-slideout">
            <div id="table-column-config">
                <div class="table-config-close" @click="tableConfigClose()">
                    <p> <i class="fas fa-times"></i> </p>
                </div>
                <div :key="checkboxesKey">
                    <div class="table-checkbox-container" v-for="(checkbox, key) in checkboxes" :id="key" :key="key">
                        <template v-if="key === 'addition_check' && hideAddition">
                            <span> {{checkbox.name}}</span>
                            <b-form-checkbox
                                    v-b-tooltip.hover :title="checkbox.value ? 'Afiseaza' : 'Ascunde'"
                                    v-model="checkbox.value"
                                    :name="key"
                                    @change="changeCheckbox(key)"
                                    switch
                            >
                            </b-form-checkbox>
                        </template>
                        <template v-else-if="key !== 'addition_check'">
                            <span> {{checkbox.name}} </span>
                            <b-form-checkbox
                                    v-b-tooltip.hover :title="checkbox.value ? 'Afiseaza' : 'Ascunde'"
                                    v-model="checkbox.value"
                                    :name="key"
                                    @change="changeCheckbox(key)"
                                    switch
                            >
                            </b-form-checkbox>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div id="product-slideout" class="closest-wrapper">
            <products :userWarehouses="this.userWarehouses"
                      :warehouses="this.warehouses"
                      @addItem="addItem"/>
        </div>
        <div id="offers-slideout">
          <productsfromoffer :select_client="select_client"
                              @addItem="addItem"
                              @removeItemFromOffer="removeItemFromOffer"/>

        </div>
        <b-modal id="modal-scrollable" size="xl" scrollable hide-header no-close-on-backdrop>
            <template slot="default">
                <div class="offer-header">
                    <div class="page-title">
                        <h5> Previzualizare comanda </h5>
                    </div>
                </div>
                <div class="general-template-info">
                    <ul>
                        <li>
                            <p class="main-heading"> {{$t('txt.numarComanda')}} </p>
                            <p> AUTO  </p>
                        </li>
                        <li>
                            <p class="main-heading"> {{$t('txt.data')}}  </p>
                            <p> {{new Date() | moment("DD.MM.YYYY")}} </p>
                        </li>
                    </ul>
                </div>
                <div class="row justify-content-center">
                  <div class="col-xl-6 col-lg-6 col-md-12">
                    <ul class="template-offer-details" v-if="select_client">
                        <h4> {{$t('txt.dateClient')}} </h4>
                        <li> <span> {{$t('placeholder.numeCompanie')}}: </span> <p>{{select_client.company_name ? select_client.company_name : '-'}} </p> </li>
                        <li> <span> {{$t('placeholder.nume')}}: </span> <p>{{select_client.last_name}} {{select_client.first_name}} </p> </li>
                        <li> <span> {{$t('placeholder.email')}}: </span> <p>{{select_client.email}} </p> </li>
                        <li> <span> {{$t('placeholder.telefon')}}: </span> <p>{{select_client.phone}} </p> </li>
                    </ul>
                  </div>
                </div>
                <h4> {{$t('txt.comandaFinala')}} </h4>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead>
                        <tr>
                            <th>
                                <span>
                                    {{$t('tableHeader.nrCrt')}}
                                </span>
                            </th>
                            <th v-if="!checkboxes['name_check'].value">
                                <span>
                                    {{$t('placeholder.denumire')}}
                                </span>
                            </th>
                            <th v-if="!checkboxes['quantity_check'].value">
                                <span>
                                    {{$t('placeholder.cantitate')}}
                                </span>
                            </th>
                            <th v-if="!checkboxes['price_check'].value">
                                <span>
                                    {{$t('placeholder.pret')}}
                                </span>
                            </th>
                            <th v-if="!checkboxes['subtotal_check'].value">
                                <span>
                                    {{$t('txt.subtotal')}}
                                </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(order_row,index) in order_rows.products" :key="`modal-products-${index}`">
                            <td>
                                <p> {{index + 1}} </p>
                            </td>
                            <td v-if="!checkboxes['name_check'].value" :tableheadData="$t('placeholder.denumire')">
                                <span> {{order_row.name}} </span>
                            </td>
                            <td v-if="!checkboxes['quantity_check'].value" :tableheadData="$t('placeholder.cantitate')">
                                <span> {{order_row.qty}} </span>
                            </td>
                            <td v-if="!checkboxes['price_check'].value" :tableheadData="$t('placeholder.pret')">
                                <span> {{order_row.price | formatPrice}} </span>
                            </td>
                            <td v-if="!checkboxes['subtotal_check'].value" :tableheadData="$t('txt.subtotal')">
                                <span> {{(order_row.price * order_row.qty) | formatPrice}} </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <ul class="template-preview-total">
                    <li>
                        <h5> Procent adaos total  </h5>
                        <p> {{this.addition().value | formatPrice}} % </p>
                    </li>
                    <li>
                        <h5> {{$t('txt.subtotal')}}  </h5>
                        <p> {{this.subtotal() | formatPrice}} </p>
                    </li>
                    <li>
                        <h5> {{$t('tableHeader.discount')}}  </h5>
                        <p> {{this.discountTotal().value | formatPrice}} ({{this.discountTotal().percentage | formatPrice}} %) </p>
                    </li>
                    <li>
                        <h5> {{$t('txt.total')}}  </h5>
                        <p> {{this.total() | formatPrice}}</p>
                    </li>
                </ul>
            </template>
            <template slot="modal-footer" slot-scope="{ ok }">
                <div class="modal-certified-label">
                    <div class="modal-certified-logo">
                        <img src="/logo.png" alt="user-logo">
                    </div>
                    <p v-if="$hasRole(['partner'])"> {{$t('placeholder.partenerCompanie')}} </p>
                </div>
                <div class="modal-bottom-wrapper">
                    <button type="button" class="template-button" @click="closeModal()">
                        {{$t('txt.inchide')}}
                    </button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import ProductsService from '../../api-services/products.service'
import OrdersService from '../../api-services/orders.service'
import localforage from 'localforage'
import Products from '../../components/Products'
import ProductsFromOffer from '../../components/ProductsFromOffer'
import Clients from '../../components/Clients'
import { EventBus } from '../../main.js'

export default {
  name: 'Editorder',
  data () {
    return {
      logo: null,
      user: this.$store.getters.user,
      userWarehouses: null,
      warehouses: null,
      lastRequest: null,
      selected: null,
      globalPriceRange: {
        key: 5,
        name: 'pp_amanunt'
      },
      select_client_clone: null,
      priceCategoryes: null,
      selected_search_header: null,
      select_client: null,
      products: null,
      post_services: null,
      services: null,
      search_services: '',
      search_post_services: '',
      discount: 0,
      previewPdf: null,
      order_rows: {
        products: [],
        services: [],
        post_services: []
      },
      meta_products: {},
      meta_services: {},
      meta_post_services: {},
      show_location_name: false,
      delivery_info: null,
      ammount: 0,
      order_total: null,
      pts_rewards_partner: null,
      pts_rewards_employee: null,
      selected_status: null,
      changeClientOrder: false,
      order: null,
      order_points: null,
      orderClone: null,
      clientClone: null,
      initialClientFromOrderClone: null,
      select_partner: null,
      objective: null,
      representative_products: null,
      action_button_state: null,
      checkboxesKey: 1,
      checkboxes: {
        name_check: { value: false, name: 'Denumire' },
        price_check: { value: false, name: 'Tip pret' },
        addition_check: { value: true, name: 'Adaos' },
        discount_check: { value: true, name: 'Discount' },
        quantity_check: { value: false, name: 'Cantitate' },
        subtotal_check: { value: false, name: 'Subtotal' }
      },
      hideAddition: true,
      settings_amount: 0,
      check_addition: false,
      totalDiscountCheckbox: false,
      search_results_orders: [],
      search_results_offers: [],
      lastDataPriceActive: null,
      lastDataAdditionActive: null,
      lastDataDiscountActive: null,
      lastDataQtyActive: null,
      actionChangePriceSelect: false
    }
  },
  components: {
    'products': Products,
    'productsfromoffer': ProductsFromOffer,
    'clients': Clients
  },
  watch: {
  },
  methods: {
    showModal () {
      this.action_button_state = 1
      this.$bvModal.show('modal-scrollable')
      let tableConfig = document.getElementById('table-column-config')
      tableConfig.classList.remove('config-active')
    },
    closeModal () {
      this.action_button_state = undefined
      this.$bvModal.hide('modal-scrollable')
    },
    async saveOrder () {
      if (!this.select_client) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }

      let validatorResp = true
      await this.$refs.clientCompRef.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$refs.clientCompRef.$validator.errors && !result) {
          this.$refs.clientCompRef.select_client_form_status = true
          this.$refs.clientCompRef.checked = false
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }

      if (this.order_rows.products.length === 0) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.ofertaGoala'),
          'animation-type': 'css'
        })
        return false
      }

      let data = {
        client: this.select_client,
        client_id: this.select_client.id,
        products: this.order_rows.products,
        discount: this.discount,
        objective: this.objective,
        delivery_address: {},
        showTotalDiscount: this.totalDiscountCheckbox,
        totalDiscount: this.discountTotal(),
        representative_products: this.representative_products
      }
      if (this.select_partner) {
        data['partner_id'] = this.select_partner.id
      }
      if (this.selected_status) {
        data.order_status = this.selected_status.id
      }

      data['county'] = this.select_client.county ? this.select_client.county.id : null
      data['city'] = this.select_client.city ? this.select_client.city.id : null

      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()

      OrdersService.update(this.$route.params.id, data)
        .then((response) => {
          this.updateClientLocalforage(this.select_client)
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.comandaSalvata'),
            'animation-type': 'css'
          })
          this.$router.push('/orders')
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
          this.closeSlideout()
        })
    },
    changeCheckbox (name) {
      if (name === 'addition_check') {
        if (this.checkboxes[name].value === true) {
          if (confirm('Sunteti sigur?')) {
            this.checkboxes[name].value = !this.checkboxes[name].value
          }
        } else {
          this.checkboxes[name].value = !this.checkboxes[name].value
        }
      } else {
        this.checkboxes[name].value = !this.checkboxes[name].value
      }
      this.checkboxesKey++
    },
    tableConfigClose () {
      this.action_button_state = undefined
      let tableConfig = document.getElementById('table-column-config')
      tableConfig.classList.remove('config-active')
      this.$root.$emit('bv::hide::tooltip')
    },
    addition () {
      let totalMin = 0
      let addition = []
      addition['value'] = '0.00'
      addition['percentage'] = '0.00'
      if (this.order_rows.products.length) {
        this.order_rows.products.forEach(function (element) {
          totalMin += parseFloat(element.prices.pp_minim).toFixed(2) * parseInt(element.qty)
        })
        addition['value'] = (parseFloat(this.total()).toFixed(4) - parseFloat(totalMin).toFixed(4)) / 1.19
        addition['percentage'] = ((100 * parseFloat(addition['value']).toFixed(2)) / parseFloat(totalMin / 1.19).toFixed(2)) || 0
        return addition
      }
      return addition
    },
    discountTotal () {
      let totalMax = 0
      this.order_rows.products.forEach(function (element) {
        totalMax += parseFloat(element.prices.pp_amanunt).toFixed(2) * parseInt(element.qty)
      })
      let disscountTotal = {}
      disscountTotal.value = -(this.total() - totalMax)
      disscountTotal.value = disscountTotal.value > 0 ? disscountTotal.value : 0.00
      disscountTotal.percentage = ((100 * disscountTotal.value) / totalMax) || 0
      disscountTotal.percentage = disscountTotal.percentage > 0 ? disscountTotal.percentage : 0.00
      disscountTotal.value = parseFloat(disscountTotal.value).toFixed(2)
      disscountTotal.percentage = parseFloat(disscountTotal.percentage).toFixed(2)
      return disscountTotal
    },
    changeAdditionUnder (index) {
      for (let i = index + 1; i < this.order_rows.products.length; i++) {
        this.order_rows.products[i].addition = this.order_rows.products[index].old_addition_fixed || this.order_rows.products[index].addition
        this.inputAdditionProduct(i)
        this.changeAdditionDiscountProduct(i)
      }
    },
    changeDiscountUnder (index) {
      for (let i = index + 1; i < this.order_rows.products.length; i++) {
        this.order_rows.products[i].discount = this.order_rows.products[index].old_discount_fixed || this.order_rows.products[index].addition
        this.inputDiscountProduct(i)
        this.changeAdditionDiscountProduct(i)
      }
    },
    activatePriceInput (index) {
      this.lastDataPriceActive = index
      window.$('[data-price-active=' + this.lastDataPriceActive + ']').focus().select()
    },
    activateAdditionInput (index) {
      this.lastDataAdditionActive = index
      window.$('[data-addition-active=' + this.lastDataAdditionActive + ']').focus().select()
    },
    activateQtyInput (index) {
      this.lastDataQtyActive = index
      window.$('[data-qty-active=' + this.lastDataQtyActive + ']').focus().select()
    },
    activateDiscountInput (index) {
      this.lastDataDiscountActive = index
      window.$('[data-discount-active=' + this.lastDataDiscountActive + ']').focus().select()
    },
    increaseDataPrice () {
      this.lastDataPriceActive = this.lastDataPriceActive < this.order_rows.products.length - 1 ? this.lastDataPriceActive + 1 : this.lastDataPriceActive
      window.$('[data-price-active=' + this.lastDataPriceActive + ']').focus().select()
    },
    increaseDataAddition () {
      this.lastDataAdditionActive = this.lastDataAdditionActive < this.order_rows.products.length - 1 ? this.lastDataAdditionActive + 1 : this.lastDataAdditionActive
      window.$('[data-addition-active=' + this.lastDataAdditionActive + ']').focus().select()
    },
    increaseDataQty () {
      this.lastDataQtyActive = this.lastDataQtyActive < this.order_rows.products.length - 1 ? this.lastDataQtyActive + 1 : this.lastDataQtyActive
      window.$('[data-qty-active=' + this.lastDataQtyActive + ']').focus().select()
    },
    increaseDataDiscount () {
      this.lastDataDiscountActive = this.lastDataDiscountActive < this.order_rows.products.length - 1 ? this.lastDataDiscountActive + 1 : this.lastDataDiscountActive
      window.$('[data-discount-active=' + this.lastDataDiscountActive + ']').focus().select()
    },

    toggleSlideOut (target) {
      let sliderOffers = document.getElementById('offers-slideout')
      let sliderProducts = document.getElementById('product-slideout')
      let mainContainer = document.getElementById('page-content-wrapper')
      let searchProducts = document.getElementById('product-search')
      let searchProductsOffers = document.getElementById('product-search-offer')
      let tableConfig = document.getElementById('table-column-config')
      switch (target) {
        case 'products':
          this.action_button_state = 2
          sliderOffers.classList.remove('slideout-open')
          sliderProducts.classList.add('slideout-open')
          mainContainer.classList.add('changed-position')
          tableConfig.classList.remove('config-active')
          searchProducts.focus()
          break
        case 'offers':
          this.action_button_state = 3
          sliderProducts.classList.remove('slideout-open')
          sliderOffers.classList.add('slideout-open')
          mainContainer.classList.add('changed-position')
          tableConfig.classList.remove('config-active')
          searchProductsOffers.focus()
          break
        case 'table-config':
          this.action_button_state = 4
          mainContainer.classList.remove('changed-position')
          sliderProducts.classList.remove('slideout-open')
          sliderOffers.classList.remove('slideout-open')
          tableConfig.classList.add('config-active')
          break
        default:
      }
    },
    closeSlideout () {
      this.action_button_state = undefined
      window.$('.action-button').removeClass('action-button-active')
      window.$('#offers-slideout').removeClass('slideout-open')
      window.$('#product-slideout').removeClass('slideout-open')
      window.$('#page-content-wrapper').removeClass('changed-position')
    },
    checkLogo () {
      if (this.user.logo && this.user.logo.length) {
        this.logo = this.user.logo[0].link
      } else {
        this.logo = null
      }
    },
    getQty (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return element.warehouse_id === warehouseId
        })
        if (stock) {
          return stock.qty
        }
      }
      return 0
    },
    getQtyReserved (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return element.warehouse_id === warehouseId
        })
        if (stock) {
          return stock.reserved
        }
      }
      return 0
    },
    getOrder () {
      this.$store.dispatch('showLoading')
      return new Promise((resolve, reject) => {
        OrdersService.get(this.$route.params.id)
          .then((response) => {
            let result = response.data.data
            this.order = result
            // this.selected_city_location = this.cities_location.find(city => city.id === this.order.delivery_info.id)
            this.order_rows.products = result.products
            for (let i = 0; i < this.order_rows.products.length; i++) {
              this.changePriceProductInput(i)
            }
            this.order_rows.services = result.services
            this.order_rows.post_services = result.post_services
            this.selected_status = this.formatStatuses(result.status)
            this.pts_rewards_employee = result.pts_rewards_employee
            this.pts_rewards_partner = result.pts_rewards_partner
            this.order_points = this.orderPoints(this.order.total)
            this.discount = result.discount_input
            this.objective = result.objective
            // this.changeClientOrder = false

            let dataEmit = {
              clientId: result.client.id,
              partnerId: result.partner ? result.partner.id : null
            }
            this.$refs.clientCompRef.editPreselectedClient(dataEmit)

            this.representative_products = result.representative_products
            this.totalDiscountCheckbox = Boolean(parseInt(result.show_total_discount))
            this.initialClientFromOrderClone = _.cloneDeep(this.select_client)
            this.clientClone = _.cloneDeep(this.select_client)
            this.orderClone = _.cloneDeep(this.order)
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    orderPoints (total) {
      return Math.ceil(total / this.order.settings_amount)
    },
    formatStatuses (status) {
      status = parseInt(status)
      let orderStatus = ''
      switch (status) {
        case 1: orderStatus = { id: 1, label: 'Comanda noua' }
          break
        case 2: orderStatus = { id: 2, label: 'Pregatita de livrare' }
          break
        case 3: orderStatus = { id: 3, label: 'Finalizata' }
          break
        case 4: orderStatus = { id: 4, label: 'Anulata' }
          break
      }
      return orderStatus
    },
    getPartnersFromLocalForage () {
      return localforage.getItem('partners').then((response) => {
        this.partners = response.sort((a, b) => {
          let textA = ''
          let textB = ''
          if (a.company_name === null) {
            textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
          } else {
            textA = a.company_name.toUpperCase().trim()
          }
          if (b.company_name === null) {
            textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
          } else {
            textB = b.company_name.toUpperCase().trim()
          }
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      })
    },
    getWarehouses () {
      ProductsService.getWarehouses()
        .then((response) => {
          this.warehouses = response.data.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    increaseQuantity (index, collection) {
      this[collection][index]['qty']++
      this.checkQuantity(index, collection)
    },
    decreaseQuantity (index, collection) {
      this[collection][index]['qty']--
      this.checkQuantity(index, collection)
    },
    checkQuantity (product, inputs, offerId) {
      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].value > 0) {
          if (product.stock.length > 0) {
            let stock = product.stock.find(row => parseInt(row.warehouse_id) === parseInt(inputs[i].getAttribute('data-warehouse-id')))
            if (stock) {
              let localProd = this.order_rows.products.find(prod => parseInt(prod.id) === parseInt(product.id) && parseInt(prod.offerId) !== parseInt(offerId))
              let localProdOrder = this.order_rows.products.find(prod => parseInt(prod.id) === parseInt(product.id) && parseInt(prod.offerId) === parseInt(offerId))
              let existProdQty = localProd ? localProd.qty : 0
              let qtyAdd = null
              // if (offerId > 0) {
              //   qtyAdd = parseInt(inputs[i].value)
              // } else {
              qtyAdd = parseInt(inputs[i].value) + parseInt(existProdQty)
              // }
              if (qtyAdd > parseInt(stock.qty)) {
                this.$notify({
                  group: 'warning',
                  type: 'warn',
                  text: 'Din pacate mai sunt doar ' + stock.qty + ' buc. pe stoc in depozitul ' + inputs[i].getAttribute('data-warehouse-name') + ' pentru acest produs',
                  'animation-type': 'css'
                })
                if (!localProdOrder && offerId > 0) {
                  let objData = {
                    offerId: offerId,
                    productId: product.id
                  }
                  EventBus.$emit('uncheckFromOffer', objData)
                }
                return false
              } else {
                let productInvoice = this.order_rows.products.find(row => row.id === product.id)
                if (productInvoice) {
                  let warehouseInvoice = productInvoice.warehouses.find(row => row.id === parseInt(inputs[i].getAttribute('data-warehouse-id')))
                  let qtyAddVal = 0
                  let warehouseInvoiceQty = warehouseInvoice ? warehouseInvoice.qty : 0
                  qtyAddVal = parseInt(inputs[i].value) + parseInt(warehouseInvoiceQty)
                  if (warehouseInvoice && (qtyAddVal > parseInt(stock.qty))) {
                    this.$notify({
                      group: 'warning',
                      type: 'warn',
                      text: 'Din pacate mai sunt doar ' + stock.qty + ' buc. pe stoc in depozitul ' + inputs[i].getAttribute('data-warehouse-name') + ' pentru acest produs',
                      'animation-type': 'css'
                    })
                    if (!localProdOrder && offerId > 0) {
                      let objData = {
                        offerId: offerId,
                        productId: product.id
                      }
                      EventBus.$emit('uncheckFromOffer', objData)
                    }
                    return false
                  }
                }
              }
            } else {
              this.$notify({
                group: 'warning',
                type: 'warn',
                text: 'Din pacate nu aveti stoc in depozitul ' + inputs[i].getAttribute('data-warehouse-name') + ' pentru acest produs',
                'animation-type': 'css'
              })
              if (offerId > 0) {
                let objData = {
                  offerId: offerId,
                  productId: product.id
                }
                EventBus.$emit('uncheckFromOffer', objData)
              }
              return false
            }
          } else {
            this.$notify({
              group: 'warning',
              type: 'warn',
              text: 'Din pacate nu aveti stoc pentru acest produs',
              'animation-type': 'css'
            })
            if (offerId > 0) {
              let objData = {
                offerId: offerId,
                productId: product.id
              }
              EventBus.$emit('uncheckFromOffer', objData)
            }
            return false
          }
        }
      }

      return true
    },
    removeItemFromOffer (data) {
      let index = this.order_rows.products.findIndex(el => el.id === data.productId && el.offerId === data.offerId)
      if (index >= 0) {
        this.order_rows.products.splice(index, 1)
      }
    },
    changeQty (index) {
      this.order_rows.products[index].qty = this.order_rows.products[index].qty > 0 ? this.order_rows.products[index].qty : 1
      this.order_rows.products[index].warehouses[0].qty = this.order_rows.products[index].qty
    },
    addItem (data) {
      let row = null
      if (data.offerId) {
        data.productInfo = data.product
        data.product = data.product.data
        row = this.order_rows.products.find(r => r.id === data.product.id && r.offerId === data.offerId)
      } else {
        row = this.order_rows.products.find(r => r.id === data.product.id && r.offerId === null)
      }
      // if (this.checkQuantity(data.product, data.inputs, data.offerId || null) === false) {
      //   return false
      // }
      if (row) {
        let ok = false
        for (let i = 0; i < data.inputs.length; i++) {
          if (data.inputs[i].value > 0) {
            ok = true
            let warehouse = row.warehouses.find(warehouse => parseInt(warehouse.id) === parseInt(data.inputs[i].getAttribute('data-warehouse-id')))
            if (warehouse) {
              if (data.offerId) {
                warehouse.qty = parseInt(data.inputs[i].value)
              } else {
                warehouse.qty = parseInt(warehouse.qty) + parseInt(data.inputs[i].value)
              }
            } else {
              row.warehouses.push({
                id: data.inputs[i].getAttribute('data-warehouse-id'),
                name: data.inputs[i].getAttribute('data-warehouse-name'),
                key: data.inputs[i].getAttribute('data-warehouse-key'),
                qty: parseInt(data.inputs[i].value)
              })
            }
            if (!data.offerId) {
              row.qty = parseInt(row.qty) + parseInt(data.inputs[i].value)
              data.inputs[i].value = null
            } else {
              row.qty = parseInt(data.inputs[i].value)
            }
          }
        }
        if (!ok) {
          this.$notify({
            group: 'error',
            type: 'error',
            // title: 'Added',
            text: 'Specificati cantitatea pentru adaugare',
            'animation-type': 'css'
          })
        }
      } else {
        let dataQty = []
        let ok = false
        let totalQty = 0
        for (let i = 0; i < data.inputs.length; i++) {
          if (data.inputs[i].value > 0) {
            ok = true
            dataQty.push({
              id: data.inputs[i].getAttribute('data-warehouse-id'),
              name: data.inputs[i].getAttribute('data-warehouse-name'),
              key: data.inputs[i].getAttribute('data-warehouse-key'),
              qty: data.inputs[i].value
            })
            if (!data.offerId) {
              totalQty = parseInt(totalQty) + parseInt(data.inputs[i].value)
              data.inputs[i].value = null
            } else {
              totalQty = parseInt(data.inputs[i].value)
            }
          }
        }
        if (ok) {
          let obj = {
            id: data.product.id,
            offerId: data.offerId || null,
            warehouses: dataQty,
            price_category: _.clone(this.globalPriceRange.key),
            price_category_name: _.clone(this.globalPriceRange.name),
            price: data.offerId ? data.productInfo.price : data.product.prices[_.clone(this.globalPriceRange.name)],
            prices: data.product.prices,
            name: data.product.name,
            qty: totalQty,
            um: data.product.um
          }
          obj['addition'] = parseFloat((obj.price - data.product.prices.pp_minim) / data.product.prices.pp_minim * 100).toFixed(2)
          obj['discount'] = parseFloat(-(obj.price - data.product.prices['pp_amanunt']) / data.product.prices['pp_amanunt'] * 100).toFixed(2)

          this.order_rows.products.push(obj)
          this.changePriceProductInput(this.order_rows.products.lastIndexOf(obj))
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: 'Produsul a fost adaugat in comanda',
            'animation-type': 'css'
          })

          if (!data.offerId) {
            let searchProducts = document.getElementById('product-search')
            searchProducts.select()
            EventBus.$emit('lastDataActive', null)
            let collapsedAriaBtn = window.$('[aria-expanded=true]').attr('aria-controls')
            if (collapsedAriaBtn) {
              this.$root.$emit('bv::toggle::collapse', collapsedAriaBtn)
            }
          }
        } else {
          if (!ok) {
            this.$notify({
              group: 'error',
              type: 'error',
              // title: 'Added',
              text: 'Specificati cantitatea pentru adaugare',
              'animation-type': 'css'
            })
            if (data.offerId > 0) {
              let objData = {
                offerId: data.offerId,
                productId: data.product.id
              }
              EventBus.$emit('uncheckFromOffer', objData)
            }
          }
        }
      }
      this.scrollToLastProduct(data, 'offer-table-wrapper')
    },

    changePriceProducts () {
      if (!this.actionChangePriceSelect) return false
      let priceCat = this.priceCategoryes.find(price => parseInt(price.value) === parseInt(this.globalPriceRange.key))
      this.globalPriceRange.name = priceCat.name
      for (let i = 0; i < this.order_rows.products.length; i++) {
        this.order_rows.products[i].price_category = this.globalPriceRange.key
        this.order_rows.products[i].price = this.order_rows.products[i].prices[this.globalPriceRange.name]
        this.order_rows.products[i].price_fixed = this.order_rows.products[i].prices[this.globalPriceRange.name]
        this.order_rows.products[i].price_category_name = this.globalPriceRange.name
        this.order_rows.products[i].price_category_indicator = 'stable'
        this.order_rows.products[i].addition = parseFloat((this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_minim) / this.order_rows.products[i].prices.pp_minim * 100).toFixed(2)
        this.order_rows.products[i].discount = parseFloat(-(this.order_rows.products[i].price - this.order_rows.products[i].prices['pp_amanunt']) / this.order_rows.products[i].prices['pp_amanunt'] * 100).toFixed(2)
      }
    },
    changePriceProduct (i) {
      let priceCat = this.priceCategoryes.find(price => price.value === this.order_rows.products[i].price_category)
      this.order_rows.products[i].price = this.order_rows.products[i].prices[priceCat.name]
      this.order_rows.products[i].price_category_name = priceCat.name
      this.order_rows.products[i].price_category_indicator = 'stable'
      this.order_rows.products[i].addition = parseFloat((this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_minim) / this.order_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.order_rows.products[i].discount = parseFloat(-(this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_amanunt) / this.order_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.order_rows.products[i].price_fixed = this.order_rows.products[i].price
    },
    changePriceProductInput (i) {
      this.order_rows.products[i].addition = parseFloat((this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_minim) / this.order_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.order_rows.products[i].discount = parseFloat(-(this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_amanunt) / this.order_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.order_rows.products[i].discount = this.order_rows.products[i].discount > 0 ? this.order_rows.products[i].discount : parseFloat(0.00).toFixed(2)
      this.machProductPriceCategory(i)
      this.order_rows.products[i].price_fixed = this.order_rows.products[i].price
    },
    inputDiscountProduct (i) {
      let prodDiscount = this.order_rows.products[i].discount > 0 ? this.order_rows.products[i].discount : 0
      this.order_rows.products[i].price = parseFloat(this.order_rows.products[i].price_fixed - prodDiscount / 100 * this.order_rows.products[i].price_fixed)
      this.order_rows.products[i].old_discount_fixed = this.order_rows.products[i].discount
      this.machProductPriceCategory(i)
    },
    inputAdditionProduct (i) {
      let prodAddition = this.order_rows.products[i].addition > 0 ? this.order_rows.products[i].addition : 0
      this.order_rows.products[i].price = parseFloat(Number(this.order_rows.products[i].price_fixed) + Number(prodAddition) / 100 * Number(this.order_rows.products[i].price_fixed))
      this.order_rows.products[i].old_addition_fixed = this.order_rows.products[i].addition
      this.machProductPriceCategory(i)
    },
    changeAdditionDiscountProduct (i) {
      this.changeInputNull(i)
      this.order_rows.products[i].price_fixed = parseFloat(this.order_rows.products[i].price).toFixed(2)
      this.order_rows.products[i].addition = parseFloat((this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_minim) / this.order_rows.products[i].prices.pp_minim * 100).toFixed(2)
      this.order_rows.products[i].addition = this.order_rows.products[i].addition > 0 ? this.order_rows.products[i].addition : parseFloat(0.00).toFixed(2)
      this.order_rows.products[i].discount = parseFloat(-(this.order_rows.products[i].price - this.order_rows.products[i].prices.pp_amanunt) / this.order_rows.products[i].prices.pp_amanunt * 100).toFixed(2)
      this.order_rows.products[i].discount = this.order_rows.products[i].discount > 0 ? this.order_rows.products[i].discount : parseFloat(0.00).toFixed(2)
      this.order_rows.products[i].price = parseFloat(this.order_rows.products[i].price).toFixed(2)
    },
    changeInputNull (i) {
      this.order_rows.products[i].addition = this.order_rows.products[i].addition > 0 ? this.order_rows.products[i].addition : parseFloat(0.00).toFixed(2)
      this.order_rows.products[i].discount = this.order_rows.products[i].discount > 0 ? this.order_rows.products[i].discount : parseFloat(0.00).toFixed(2)
    },
    machProductPriceCategory (index) {
      let prices = this.order_rows.products[index].prices
      prices = Object.keys(prices).map(function (key) {
        return { value: parseFloat(prices[key]), name: key }
      })
      prices.push({ value: parseFloat(this.order_rows.products[index].price), name: 'selected_price' })
      prices = prices.sort((a, b) => a.value >= b.value ? 1 : -1)

      let priceCatName = null
      let priceCatIndicator = 'stable'
      for (let i = 0; i < prices.length; i++) {
        if (prices[i].name === 'selected_price' && i === 0) {
          priceCatName = prices[i + 1].name
          if (prices[i].value === prices[i + 1].value) {
            priceCatIndicator = 'stable'
          } else {
            priceCatIndicator = 'down'
          }
          break
        }

        if (prices[i].name === 'selected_price' && i === prices.length - 1) {
          priceCatName = prices[i - 1].name
          if (prices[i].value === prices[i - 1].value) {
            priceCatIndicator = 'stable'
          } else {
            priceCatIndicator = 'up'
          }
          break
        }

        if (prices[i].name === 'selected_price') {
          if (prices[i].value === prices[i - 1].value) {
            priceCatName = prices[i - 1].name
            priceCatIndicator = 'stable'
            break
          }

          if (prices[i].value === prices[i + 1].value) {
            priceCatName = prices[i + 1].name
            priceCatIndicator = 'stable'
            break
          }

          if (prices[i].value <= (prices[i - 1].value + prices[i + 1].value) / 2) {
            priceCatName = prices[i - 1].name
            priceCatIndicator = 'up'
            break
          } else {
            priceCatName = prices[i + 1].name
            priceCatIndicator = 'down'
            break
          }
        }
      }

      let priceCat = this.priceCategoryes.find(p => p.name === priceCatName)
      if (priceCat) {
        this.order_rows.products[index].price_category_indicator = priceCatIndicator
        this.order_rows.products[index].price_category_name = priceCatName
        this.order_rows.products[index].price_category = priceCat.value
        return true
      } else {
        this.order_rows.products[index].price_category_indicator = null
        this.order_rows.products[index].price_category_name = null
        this.order_rows.products[index].price_category = null
        return null
      }
    },
    increasePoints (item, initialQty) {
      if (this.$hasRole('employee') || this.$hasRole('admin')) {
        this.pts_rewards_employee = this.total / this.order.settings_amount
      }
      if (this.$hasRole('partner')) {
        this.pts_rewards_partner = this.total / this.order.settings_amount
      }
    },
    removeItem (index, collection) {
      if (this.order_rows[collection][index].offerId !== null) {
        let data = {
          offerId: this.order_rows[collection][index].offerId,
          productId: this.order_rows[collection][index].id,
          warehouse: this.order_rows[collection][index].warehouses
        }
        EventBus.$emit('uncheckFromOffer', data)
      }
      this.order_rows[collection].splice(index, 1)
    },
    editOrder () {
      let vm = this
      if (!this.select_client) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.selected_status) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectStatus'),
          'animation-type': 'css'
        })
        return false
      }
      if (this.order_rows.products.length === 0 && this.order_rows.services.length === 0 && this.order_rows.post_services.length === 0) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.comandaGoala'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.select_county) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.judetDetaliiFacturare'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.select_city) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.orasDetaliiFacturare'),
          'animation-type': 'css'
        })
        return false
      }
      let data = {
        client: this.select_client.id,
        products: this.order_rows.products,
        services: this.order_rows.services,
        post_services: this.order_rows.post_services,
        discount: this.discount,
        delivery_address: {},
        user_id: this.select_client.id,
        objective: this.objective
      }
      if (this.selected_status) {
        data.status = this.selected_status.id
      }
      if (this.select_partner) {
        data['partner_id'] = this.select_partner.id
      }
      if (this.select_city.id !== '' && this.select_county.id !== '') {
        data['county'] = this.select_county.id
        data['city'] = this.select_city.id
      }
      this.client_fields.column_1.forEach(function (element) {
        if (element.inputName !== 'county' && element.inputName !== 'city') {
          data[element.inputName] = element.inputValue
        }
      })
      this.client_fields.column_2.forEach(function (element) {
        if (element.inputName !== 'county' && element.inputName !== 'city') {
          data[element.inputName] = element.inputValue
        }
      })
      this.client_fields.location.forEach(function (element) {
        if (element.inputName === 'county') {
          data['delivery_address'][element.inputName] = vm.selected_county_location.id
        } else if (element.inputName === 'city') {
          data['delivery_address'][element.inputName] = vm.selected_city_location.id
        } else {
          data['delivery_address'][element.inputName] = element.inputValue
        }
      })
      // return false
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      OrdersService.update(this.$route.params.id, data)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.comandaSalvata'),
            'animation-type': 'css'
          })
          let orderStatus = response.data.data.status
          //  call setttings for ammount
          if (orderStatus === 3 || orderStatus === 4) {
            this.$store.dispatch('userRequest')
          }
          this.$router.push('/orders')
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    subtotal () {
      let subtotal = 0
      this.order_rows.products.forEach(function (element) {
        subtotal += element.price * element.qty
      })
      return subtotal
    },
    total () {
      let total = this.subtotal()
      let discount = this.discount
      if (discount < 0) {
        discount = 0
      }
      if (discount > 100) {
        discount = 100
      }
      if (discount > 0) {
        total = total - discount / 100 * total
      }
      if (this.$hasRole('employee') || this.$hasRole('admin')) {
        this.pts_rewards_employee = total / (this.order ? this.order.settings_amount : 0)
      }
      if (this.$hasRole('partner')) {
        this.pts_rewards_partner = total / (this.order ? this.order.settings_amount : 0)
      }
      return total
    }
  },
  async created () {
    this.$store.dispatch('showLoading')
    this.priceCategoryes = ProductsService.getPriceCategories()
    if (!this.$can(['view addition'])) {
      this.hideAddition = false
    }
    await this.getOrder()
    await this.getWarehouses()
    this.userWarehouses = this.$store.getters.user.warehouses
    this.$store.dispatch('hideLoading')
    this.checkLogo()
    this.actionChangePriceSelect = true
  },
  mounted () {
    let vm = this
    document.getElementById('composition-template-event').addEventListener('keydown', event => {
      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-price-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataPriceActive = vm.lastDataPriceActive == null ? 0 : vm.lastDataPriceActive + 1
          if (vm.lastDataPriceActive === vm.order_rows.products.length) {
            vm.lastDataPriceActive--
          }
        } else {
          vm.lastDataPriceActive = vm.lastDataPriceActive < 1 ? 0 : vm.lastDataPriceActive - 1
        }
        window.$('[data-price-active=' + vm.lastDataPriceActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-addition-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataAdditionActive = vm.lastDataAdditionActive == null ? 0 : vm.lastDataAdditionActive + 1
          if (vm.lastDataAdditionActive === vm.order_rows.products.length) {
            vm.lastDataAdditionActive--
          }
        } else {
          vm.lastDataAdditionActive = vm.lastDataAdditionActive < 1 ? 0 : vm.lastDataAdditionActive - 1
        }
        window.$('[data-addition-active=' + vm.lastDataAdditionActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-discount-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive == null ? 0 : vm.lastDataDiscountActive + 1
          if (vm.lastDataDiscountActive === vm.order_rows.products.length) {
            vm.lastDataDiscountActive--
          }
        } else {
          vm.lastDataDiscountActive = vm.lastDataDiscountActive < 1 ? 0 : vm.lastDataDiscountActive - 1
        }
        window.$('[data-discount-active=' + vm.lastDataDiscountActive + ']').focus().select()
      }

      if ((event.keyCode === 40 || event.keyCode === 38) && document.activeElement.getAttribute('data-qty-active') !== null) {
        event.preventDefault()
        if (event.keyCode === 40) {
          vm.lastDataQtyActive = vm.lastDataQtyActive == null ? 0 : vm.lastDataQtyActive + 1
          if (vm.lastDataQtyActive === vm.order_rows.products.length) {
            vm.lastDataQtyActive--
          }
        } else {
          vm.lastDataQtyActive = vm.lastDataQtyActive < 1 ? 0 : vm.lastDataQtyActive - 1
        }
        window.$('[data-qty-active=' + vm.lastDataQtyActive + ']').focus().select()
      }
    })
  },
  computed: {
    status () {
      let output = [
        {
          id: 1,
          name: 'status',
          value: 1,
          label: 'Comanda noua'
        },
        {
          id: 2,
          name: 'status',
          value: 2,
          label: 'Pregatita de livrare'
        },
        {
          id: 3,
          name: 'status',
          value: 3,
          label: 'Finalizata'
        },
        {
          id: 4,
          name: 'status',
          value: 4,
          label: 'Anulata'
        }
      ]
      return output
    },
    location_name () {
      return {
        name: [
          {
            inputName: 'location_name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          }
        ]
      }
    },
    start_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page > 2) {
        return parseInt(this.meta_products.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page + 2 < this.meta_products.last_page) {
        return parseInt(this.meta_products.current_page, 10) + 2
      } else {
        return this.meta_products.last_page
      }
    },
    // return only 5 pages for pagination
    products_pagination () {
      let pages = []
      for (let i = this.start_page_products; i <= this.stop_page_products; i++) {
        pages.push(i)
      }
      return pages
    },
    start_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page > 2) {
        return parseInt(this.meta_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page + 2 < this.meta_services.last_page) {
        return parseInt(this.meta_services.current_page, 10) + 2
      } else {
        return this.meta_services.last_page
      }
    },
    // return only 5 pages for pagination
    services_pagination () {
      let pages = []
      for (let i = this.start_page_services; i <= this.stop_page_services; i++) {
        pages.push(i)
      }
      return pages
    },
    start_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page > 2) {
        return parseInt(this.meta_post_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page + 2 < this.meta_post_services.last_page) {
        return parseInt(this.meta_post_services.current_page, 10) + 2
      } else {
        return this.meta_post_services.last_page
      }
    },
    // return only 5 pages for pagination
    post_service_pagination () {
      let pages = []
      for (let i = this.start_page_post_service; i <= this.stop_page_post_service; i++) {
        pages.push(i)
      }
      return pages
    }
  }
}
</script>
